export enum InternalTab {
  Utilization = 'utilization',
  Sessions = 'sessions',
  Lifeglovs = 'lifeglovs',
  Surveys = 'surveys'
}
